export default "__VITE_ASSET__0a8cbf33__$_?component__"